import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import { Link } from 'react-router';

const preserveLineBreaks = content => content.split('\n').join('<br />');

class AdviceItem extends React.Component {
  static propTypes = {
    advice: PropTypes.object.isRequired,
    toggleAdvice: PropTypes.func.isRequired,
    removeAdvice: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  onToggle() {
    const { advice } = this.props;
    this.props.toggleAdvice(advice.id);
  }

  onRemove() {
    const { advice } = this.props;
    this.props.removeAdvice(advice);
  }

  render() {
    const { advice } = this.props;

    return (
      <tr>
        <td className="eight wide">
          <div
            className="inner"
            dangerouslySetInnerHTML={{
              __html: preserveLineBreaks(advice.content),
            }}
          />
        </td>
        <td className="right aligned four wide">
          <div className="ui toggle checkbox">
            <input
              type="checkbox"
              checked={advice.active}
              onChange={this.onToggle}
            />
            <label>Conseil activé</label>
          </div>
        </td>
        <td className="right aligned four wide">
          <Link to={`/advices/${advice.id}`} className="ui icon button">
            <i className="settings icon" />
          </Link>
          <button className="ui negative icon button" onClick={this.onRemove}>
            <i className="remove icon" />
          </button>
        </td>
      </tr>
    );
  }
}

export default pure(AdviceItem);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/advices/AdviceItem.js